export const recaptcha = {
  init: () => {
    const form = document.getElementsByClassName('form-page__form')
    form[0].addEventListener(
      'submit',
      function validateRecaptcha(event: Event) {
        event.preventDefault() // Prevent form submission initially

        const response = (window as any).grecaptcha.getResponse() // 'grecaptcha' is available globally
        if (!response) {
          // If the reCAPTCHA response is empty, show an error message or do something else
          const spanElement = document.querySelector('.form__recaptcha-error.recaptcha-error')
          if (spanElement) {
            spanElement.classList.remove('hide')
          }
        } else {
          // If the reCAPTCHA response is present, submit the form
          const form = event.target as HTMLFormElement
          form.submit()
        }
      },
      false
    )
  },
}
